import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      alert('Thank you for subscribing!');
      setEmail('');
    }
  };

  return (
    <footer className="bg-[#3D2817] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/e5458c9a-2fee-456b-be7f-ac70621fd81d.png" 
              alt="Next Phase Logistics" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              3505 Nolen Dr<br />
              Indianapolis, IN 46234<br />
              United States
            </p>
          </div>

          <div>
            <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Newsletter
            </h3>
            <form onSubmit={handleSubscribe} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full bg-transparent border-b border-gray-600 pb-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#F5A962] transition-colors"
              />
              <button 
                type="submit"
                className="absolute right-0 bottom-2 text-[#F5A962] hover:text-[#E67E50] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
            <p className="text-gray-500 text-xs mt-2">Subscribe for updates</p>
          </div>

          <div>
            <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <div className="flex flex-col gap-2">
              <Link to="/services" className="text-sm hover:text-[#F5A962] transition-colors cursor-pointer">
                Services
              </Link>
              <Link to="/return-policy" className="text-sm hover:text-[#F5A962] transition-colors cursor-pointer">
                Returns Policy
              </Link>
              <Link to="/privacy-policy" className="text-sm hover:text-[#F5A962] transition-colors cursor-pointer">
                Privacy Policy
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Connect
            </h3>
            <div className="flex flex-col gap-2">
              <a href="tel:+13173972529" className="text-sm hover:text-[#F5A962] transition-colors cursor-pointer">
                +1 (317) 397-2529
              </a>
              <a href="mailto:mark@aikinslogistics.com" className="text-sm hover:text-[#F5A962] transition-colors cursor-pointer">
                mark@aikinslogistics.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-xs">
              © 2024 Next Phase Logistics LLC. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-xs hover:text-[#F5A962] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
